import React, { Component } from 'react'

export default class text4 extends Component {
    render() {
        return (
            <div>
                <p>rate us</p>
            </div>
        )
    }
}
